
define(['jquery', 'core', 'common/location'], function($, core, location) {
  var ReportType, updateDownloadButton;
  ReportType = {
    INCOME_STATEMENT: 'income-statement',
    BALANCE_SHEET: 'balance-sheet',
    TRANSACTIONS: 'Transactions',
    SEARCH: 'SearchTransactions'
  };
  updateDownloadButton = function(button, link) {
    return button.attr("href", link);
  };
  return {
    updateLinks: function(button, client, reportType, dateFrom, dateTo, reportTimeScale, ledgerId) {
      var url;
      url = location.apiRoot + location.reportingApiPath + (ledgerId != null ? core.getDefaultLedgers()['money.in.transit'].id === ledgerId && core.isCurrentClientBookkeeper() ? "money-in-transit/xls/" + client.id + "/" + dateFrom + "/" + dateTo : "view/xls/" + client.id + "/" + ledgerId + "/" + dateFrom + "/" + dateTo : "" + reportType + "/xls/" + client.id + "/" + reportTimeScale + "/" + dateTo);
      return updateDownloadButton(button, url);
    },
    updateLinksForSearch: function(button, reportType, searchString, ledgerId) {
      var clientId, encodedSearchString, url;
      clientId = core.getCurrentClientId();
      encodedSearchString = encodeURIComponent(searchString);
      url = location.apiRoot + location.reportingApiPath + (ledgerId != null ? "search/xls/" + clientId + "/" + ledgerId + "?pattern=" + encodedSearchString : "search/xls/" + clientId + "?pattern=" + encodedSearchString);
      return updateDownloadButton(button, url);
    },
    INCOME_STATEMENT: ReportType.INCOME_STATEMENT,
    BALANCE_SHEET: ReportType.BALANCE_SHEET,
    TRANSACTIONS: ReportType.TRANSACTIONS,
    SEARCH: ReportType.SEARCH
  };
});
